;(function($) {

    $.noty.themes.keepconTheme = {
        name: 'keepconTheme',
        helpers: {
            borderFix: function() {
                if (this.options.dismissQueue) {
                    var selector = this.options.layout.container.selector + ' ' + this.options.layout.parent.selector;
                    switch (this.options.layout.name) {
                        case 'top':
                            $(selector).css({borderRadius: '0px 0px 0px 0px'});
                            $(selector).last().css({borderRadius: '0px 0px 5px 5px'}); break;
                        case 'topCenter': case 'topLeft': case 'topRight':
                        case 'bottomCenter': case 'bottomLeft': case 'bottomRight':
                        case 'center': case 'centerLeft': case 'centerRight': case 'inline':
                        $(selector).css({borderRadius: '0px 0px 0px 0px'});
                        $(selector).first().css({'border-top-left-radius': '5px', 'border-top-right-radius': '5px'});
                        $(selector).last().css({'border-bottom-left-radius': '5px', 'border-bottom-right-radius': '5px'}); break;
                        case 'bottom':
                            $(selector).css({borderRadius: '0px 0px 0px 0px'});
                            $(selector).first().css({borderRadius: '5px 5px 0px 0px'}); break;
                        default: break;
                    }
                }
            }
        },
        modal: {
            css: {
                position: 'fixed',
                width: '100%',
                height: '100%',
                backgroundColor: '#000',
                zIndex: 10000,
                opacity: 0.6,
                display: 'none',
                left: 0,
                top: 0
            }
        },
        style: function() {

            this.$bar.css({
                overflow: 'hidden',
                background: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAoCAYAAAAPOoFWAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPZJREFUeNq81tsOgjAMANB2ov7/7ypaN7IlIwi9rGuT8QSc9EIDAsAznxvY4pXPKr05RUE5MEVB+TyWfCEl9LZApYopCmo9C4FKSMtYoI8Bwv79aQJU4l6hXXCZrQbokJEksxHo9KMOgc6w1atHXM8K9DVC7FQnJ0i8iK3QooGgbnyKgMDygBWyYFZoqx4qS27KqLZJjA1D0jK6QJcYEQEiWv9PGkTsbqxQ8oT+ZtZB6AkdsJnQDnMoHXHLGKOgDYuCWmYhEERCI5gaamW0bnHdA3k2ltlIN+2qKRyCND0bhqSYCyTB3CAOc4WusBEIpkeBuPgJMAAX8Hs1NfqHRgAAAABJRU5ErkJggg==') repeat-x scroll left top #fff"
            });

            this.$message.css({
                fontSize: '13px',
                lineHeight: '18px',
                textAlign: 'center',
                padding: '8px 24px 8px 8px',
                width: 'auto',
                position: 'relative'
            });

            this.$closeButton.css({
                position: 'absolute',
                top: 8, right: 7,
                width: 20, height: 20,
                display: 'block',
                cursor: 'pointer'
            });

            this.$buttons.css({
                padding: 5,
                textAlign: 'right',
                borderTop: '1px solid #ccc',
                backgroundColor: '#fff'
            });

            this.$buttons.find('button').css({
                marginLeft: 5
            });

            this.$buttons.find('button:first').css({
                marginLeft: 0
            });

            switch (this.options.layout.name) {
                case 'top':
                    this.$bar.css({
                        borderRadius: '0px 0px 5px 5px',
                        borderBottom: '2px solid #eee',
                        borderLeft: '2px solid #eee',
                        borderRight: '2px solid #eee',
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                    });
                    break;
                case 'topCenter': case 'center': case 'bottomCenter': case 'inline':
                this.$bar.css({
                    borderRadius: '5px',
                    border: '1px solid #eee',
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                });
                this.$message.css({fontSize: '13px', textAlign: 'center'});
                break;
                case 'topLeft': case 'topRight':
                case 'bottomLeft': case 'bottomRight':
                case 'centerLeft': case 'centerRight':
                this.$bar.css({
                    borderRadius: '5px',
                    border: '1px solid #eee',
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                });
                this.$message.css({fontSize: '13px', textAlign: 'left'});
                break;
                case 'bottom':
                    this.$bar.css({
                        borderRadius: '5px 5px 0px 0px',
                        borderTop: '2px solid #eee',
                        borderLeft: '2px solid #eee',
                        borderRight: '2px solid #eee',
                        boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.1)"
                    });
                    break;
                default:
                    this.$bar.css({
                        border: '2px solid #eee',
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
                    });
                    break;
            }

            switch (this.options.type) {
                case 'alert': case 'notification':
                this.$bar.css({backgroundColor: '#FFF', borderColor: '#CCC', color: '#444'}); break;
                case 'warning':
                    this.$bar.css({backgroundColor: '#fcf8e3', borderColor: '#fbeed5', color: '#c09853'});
                    this.$buttons.css({borderTop: '1px solid #fbeed5'}); break;
                case 'error':
                    this.$bar.css({backgroundColor: '#f2dede', borderColor: '#eed3d7', color: '#b94a48'});
                    this.$message.css({fontWeight: 'bold'});
                    this.$buttons.css({borderTop: '1px solid #eed3d7'}); break;
                case 'information':
                    this.$bar.css({backgroundColor: '#d9edf7', borderColor: '#bce8f1', color: '#3a87ad'});
                    this.$buttons.css({borderTop: '1px solid #bce8f1'}); break;
                case 'success':
                    this.$bar.css({backgroundColor: '#dff0d8', borderColor: '#d6e9c6', color: '#468847'});
                    this.$buttons.css({borderTop: '1px solid #d6e9c6'});break;
                default:
                    this.$bar.css({backgroundColor: '#FFF', borderColor: '#CCC', color: '#444'}); break;
            }
        },
        callback: {
            onShow: function() { $.noty.themes.keepconTheme.helpers.borderFix.apply(this); },
            onClose: function() { $.noty.themes.keepconTheme.helpers.borderFix.apply(this); }
        }
    };

})(jQuery);

$(document).ready(function () {
    $(document).on('click', '[data-toggle=dropdown]', function () {
        var dropdownContainer = this.parentElement;
        var position = dropdownContainer.getBoundingClientRect().top;
        var buttonHeight = dropdownContainer.getBoundingClientRect().height;

        var dropdownMenu = $(dropdownContainer).find('.dropdown-menu');
        var menuHeight = dropdownMenu.outerHeight();

        var $win = $(window);

        if (position > menuHeight && $win.height() - position < buttonHeight + menuHeight) {
            $(dropdownContainer).addClass('dropup');
        }
    });
    $( function() {
        $( ".custom-select-options" ).selectable({
            filter: "li"
        });
    });
    $(document).bind( 'chosen:dropdown_or_dropup', function (event, chosen_param) {
        var dropdownMenu = chosen_param.container.find('.chosen-drop')
        var chosen_container = chosen_param.container[0]
        var firstScrollParent = getScrollParent(chosen_container)
        dropdownMenu.css({'max-height':''})
        if (dropdownExceedsBottomViewport()) {
            if (firstScrollParent)
                dropdownMenu.css({'max-height': chosen_container.getBoundingClientRect().top - firstScrollParent.getBoundingClientRect().top})
            dropdownMenu.addClass('chosen-drop-up');
        }else{
            dropdownMenu.removeClass('chosen-drop-up');
        }

        function dropdownExceedsBottomViewport(){
            var dropdown = dropdownMenu;
            var dropdown_top = chosen_container.getBoundingClientRect().top - document.documentElement.scrollTop;
            var dropdown_height = dropdown.height();
            var viewport_height = document.documentElement.clientHeight;

            return dropdown_top + dropdown_height > viewport_height;
        }

        function getScrollParent(el) {
            const REGEXP_SCROLL_PARENT = /^(visible|hidden|auto)/
            return !(el instanceof HTMLElement) || typeof window.getComputedStyle !== 'function'
                ? null
                : el.scrollHeight >= el.clientHeight && !REGEXP_SCROLL_PARENT.test(window.getComputedStyle(el).overflowY)
                    ? el
                    : getScrollParent(el.parentElement) || document.body
        }
    });
});

window.resizeCharts = function() {
  Highcharts.charts.forEach(function(chart) {
    if(chart){
        chart.reflow();
    }
  });
}
